// PATH: src/utils/cloudinary.js
// VERSION: 2.1 — Retro-compatible (format/fetch_format), g_auto solo donde procede.

/*
  Cambios clave vs 1.0:
  - Acepta BOTH:  format: 'jpg'  o  fetch_format: 'jpg'  → genera f_jpg (o f_auto).
  - g_auto SOLO se agrega si el crop lo admite (fill, thumb, lfill, afill, fill_pad, auto, auto_pad, auto_afill).
  - Soporta alias fit: 'cover'|'contain'|'limit' → se normalizan a crops válidos.
  - Mantiene resourceType ('image'|'video'), quality, etc.
*/

const CLOUD = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

const ALLOW_G_AUTO = new Set([
  'fill', 'thumb', 'lfill', 'afill', 'fill_pad', 'auto', 'auto_pad', 'auto_afill',
]);

function normCrop({ crop, fit }) {
  // Alias comunes
  if (fit === 'cover') return 'fill';   // recorta ajustando caja → permite g_auto
  if (fit === 'contain' || fit === 'fit') return 'fit'; // NO permite g_auto
  if (fit === 'limit') return 'limit';  // NO permite g_auto
  return crop || undefined;
}

export function cld(idOrUrl, opts = {}) {
  if (!idOrUrl) return '';
  if (/^https?:\/\//i.test(idOrUrl)) return idOrUrl;

  const cloud = CLOUD || process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  if (!cloud) return '';

  const {
    resourceType = 'image', // 'image' | 'video'
    w, h,
    crop, fit,
    gravity,
    quality = 'auto',
    format,          // nuevo (preferido)
    fetch_format,    // retro-compat (v1.0)
    ...rest
  } = opts;

  const c = normCrop({ crop, fit });
  const parts = [];

  if (w) parts.push(`w_${w}`);
  if (h) parts.push(`h_${h}`);
  if (c) parts.push(`c_${c}`);

  // gravity:
  // - si el caller manda gravity explícito → lo respetamos siempre
  // - si NO manda y el crop admite g_auto → lo agregamos
  if (gravity) {
    parts.push(`g_${gravity}`);
  } else if (c && ALLOW_G_AUTO.has(c)) {
    parts.push('g_auto');
  }
  // Para c_fit / c_limit NO añadimos g_auto.

  // calidad y formato
  if (quality) parts.push(`q_${quality}`);
  const fmt = format || fetch_format || 'auto';
  if (fmt) parts.push(`f_${fmt}`);

  // extras (dpr, ar, flags, etc.) → se pasan como k_v
  for (const [k, v] of Object.entries(rest)) {
    if (v === undefined || v === null || v === '') continue;
    parts.push(`${k}_${v}`);
  }

  const tx = parts.length ? `/${parts.join(',')}` : '';
  return `https://res.cloudinary.com/${cloud}/${resourceType}/upload${tx}/${idOrUrl}`;
}
